import a1Data from './a1-schritte.json';
import a2Data from './a2-schritte.json';
import b1Data from './b1-schritte.json';
import b2Chapters from './b2-aspekte.json';

export const A1_SCHRITTE_COURSES = a1Data.courses;
export const A2_SCHRITTE_COURSES = a2Data.courses;
export const B1_SCHRITTE_COURSES = b1Data.courses;
export const B2_ASPEKTE_CHAPTERS = b2Chapters;

const SCHRITTE_DATA = { a1: a1Data, a2: a2Data, b1: b1Data };

export const VOCAB_SETS = {
  a1: {
    id: 'a1',
    level: 'A1',
    book: 'Schritte International Neu',
    title: 'Fjalët e Panjohura',
    description: 'Fjalor nga Schritte A1 — Lektionet 1–13 (A1.1 + A1.2), me përkthim shqip.',
    unitLabel: 'Lektion',
    unitsLabel: 'leksione',
  },
  a2: {
    id: 'a2',
    level: 'A2',
    book: 'Schritte International Neu',
    title: 'Fjalët e Panjohura',
    description: 'Fjalor nga Schritte A2 — Lektionet 2, 3, 5, 8, 9, 11, 12, 13, me përkthim shqip.',
    unitLabel: 'Lektion',
    unitsLabel: 'leksione',
  },
  b1: {
    id: 'b1',
    level: 'B1',
    book: 'Schritte International Neu',
    title: 'Fjalët e Panjohura',
    description: 'Fjalor nga Schritte B1 — Lektionet 1–14, me përkthim shqip.',
    unitLabel: 'Lektion',
    unitsLabel: 'leksione',
  },
  b2: {
    id: 'b2',
    level: 'B2',
    book: 'Aspekte neu B2',
    title: 'Fjalët e Panjohura',
    description: 'Fjalor nga Aspekte B2 — Kapitujt 1–10, me përkthim shqip.',
    unitLabel: 'Kapitull',
    unitsLabel: 'kapituj',
  },
};

/** @deprecated use getStats('b2') */
export const VOCAB_INFO = VOCAB_SETS.b2;

function isSchritteSet(setId) {
  return setId === 'a1' || setId === 'a2' || setId === 'b1';
}

function getSchritteEntries(setId, { courseId = null, lessonIds = null } = {}) {
  const data = SCHRITTE_DATA[setId];
  if (!data) return [];

  let lessons = data.courses.flatMap((c) => c.lessons);

  if (courseId && courseId !== 'all') {
    const course = data.courses.find((c) => c.id === courseId);
    lessons = course?.lessons ?? [];
  }
  if (lessonIds) {
    lessons = lessons.filter((l) => lessonIds.includes(l.id));
  }

  return lessons.flatMap((l) => {
    const courseIdForLesson = data.courses.find((c) =>
      c.lessons.some((x) => x.id === l.id)
    )?.id;
    return l.words.map((w) => ({
      ...w,
      type: 'word',
      lesson: l.number,
      lessonId: l.id,
      courseId: courseIdForLesson,
    }));
  });
}

function getB2ChapterEntries(chapterId, { includePhrases = true } = {}) {
  const chapter = b2Chapters.find((c) => c.id === chapterId);
  if (!chapter) return [];

  const words = chapter.modules.flatMap((m) =>
    m.words.map((w) => ({
      ...w,
      type: 'word',
      module: m.number,
      moduleId: m.id,
      chapterId: chapter.id,
      chapterNumber: chapter.number,
    }))
  );
  const phrases = includePhrases
    ? (chapter.phrases ?? []).map((p) => ({
        ...p,
        type: 'phrase',
        module: null,
        moduleId: null,
        chapterId: chapter.id,
        chapterNumber: chapter.number,
      }))
    : [];

  return [...words, ...phrases];
}

export function getEntries(
  setId,
  {
    chapterIds = null,
    lessonIds = null,
    courseId = null,
    moduleId = null,
    includePhrases = true,
  } = {}
) {
  if (isSchritteSet(setId)) {
    return getSchritteEntries(setId, { courseId, lessonIds });
  }

  const selected = chapterIds
    ? b2Chapters.filter((c) => chapterIds.includes(c.id))
    : b2Chapters;

  let entries = selected.flatMap((c) => getB2ChapterEntries(c.id, { includePhrases }));

  if (moduleId) {
    entries = entries.filter((e) => e.moduleId === moduleId);
  }

  return entries;
}

export function getStats(setId, options = {}) {
  if (isSchritteSet(setId)) {
    const entries = getEntries(setId, options);
    const data = SCHRITTE_DATA[setId];
    const lessons = data.courses.reduce((n, c) => n + c.lessons.length, 0);
    return {
      chapters: lessons,
      words: entries.length,
      phrases: 0,
      total: entries.length,
      courses: data.courses.length,
    };
  }

  const words = b2Chapters.reduce(
    (n, c) => n + c.modules.reduce((m, mod) => m + mod.words.length, 0),
    0
  );
  const phrases = b2Chapters.reduce((n, c) => n + (c.phrases?.length ?? 0), 0);
  return {
    chapters: b2Chapters.length,
    words,
    phrases,
    total: words + phrases,
    courses: 1,
  };
}

export function getCourses(setId) {
  if (!isSchritteSet(setId)) return [];
  return SCHRITTE_DATA[setId].courses;
}

export function getLessons(setId, courseId) {
  if (!isSchritteSet(setId)) return [];
  if (courseId === 'all') {
    return SCHRITTE_DATA[setId].courses.flatMap((c) => c.lessons);
  }
  return SCHRITTE_DATA[setId].courses.find((c) => c.id === courseId)?.lessons ?? [];
}

/** @deprecated use getCourses('b1') */
export function getB1Courses() {
  return getCourses('b1');
}

/** @deprecated use getLessons('b1', courseId) */
export function getB1Lessons(courseId) {
  return getLessons('b1', courseId);
}

export function shuffleArray(arr) {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}
